module.exports = __webpack_public_path__ + "static/media/view-outline-icon.89b12a61.svg";